"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerTypeSchema = exports.SchLayerTypeSchema = exports.SchLayerType = exports.PcbLayerTypeSchema = exports.PcbLayerType = exports.UnknownLayerTypeSchema = exports.UnknownLayerType = void 0;
const zod_1 = require("zod");
var UnknownLayerType;
(function (UnknownLayerType) {
    UnknownLayerType["Other"] = "Other";
})(UnknownLayerType || (exports.UnknownLayerType = UnknownLayerType = {}));
exports.UnknownLayerTypeSchema = zod_1.z.nativeEnum(UnknownLayerType);
var PcbLayerType;
(function (PcbLayerType) {
    PcbLayerType["F"] = "F";
    PcbLayerType["B"] = "B";
    PcbLayerType["Inner"] = "Inner";
    PcbLayerType["SilkS"] = "SilkS";
    PcbLayerType["Edge"] = "Edge";
    PcbLayerType["Paste"] = "Paste";
    PcbLayerType["Mask"] = "Mask";
    PcbLayerType["Other"] = "Other";
    PcbLayerType["Virtual"] = "Virtual";
})(PcbLayerType || (exports.PcbLayerType = PcbLayerType = {}));
exports.PcbLayerTypeSchema = zod_1.z.nativeEnum(PcbLayerType);
var SchLayerType;
(function (SchLayerType) {
    SchLayerType["Label"] = "Label";
    SchLayerType["NameLabel"] = "NameLabel";
    SchLayerType["ValueLabel"] = "ValueLabel";
    SchLayerType["Pin"] = "Pin";
    SchLayerType["PinName"] = "PinName";
    SchLayerType["PinNumber"] = "PinNumber";
    SchLayerType["Symbol"] = "Symbol";
    SchLayerType["Wire"] = "Wire";
    SchLayerType["Bus"] = "Bus";
    SchLayerType["Junction"] = "Junction";
    SchLayerType["BusJunction"] = "BusJunction";
    SchLayerType["Other"] = "Other";
    SchLayerType["Background"] = "Background";
    SchLayerType["Image"] = "Image";
})(SchLayerType || (exports.SchLayerType = SchLayerType = {}));
exports.SchLayerTypeSchema = zod_1.z.nativeEnum(SchLayerType);
exports.LayerTypeSchema = zod_1.z.union([exports.PcbLayerTypeSchema, exports.SchLayerTypeSchema, exports.UnknownLayerTypeSchema]);
//# sourceMappingURL=LayerType.js.map